export interface GridHeader {
    displayText?: string;
    key?: string;
    primaryField?: string;
    sort?: string | null;
    prevSort?: string | null;
    isLink?: boolean;
    isIcon?: boolean;
    iconClass?: string;
    hideSort?: boolean;
    isDate?: boolean;
    isDateTime?: boolean;
    enableFilter?: boolean;
    enableSearch?: boolean;
    uniqueItems?: any[];
    filteredUniqueItems?: { isChecked: boolean, label: string, id: number }[];
    selectedFilterCount?: string;
    headerSearchText?: string;
    isTime?: boolean;
    defaultValue?: string;
    defaultDateFormat?: string;
    defaultTimeFormat?: string;
    defaultDateTimeFormat?: string;
    isExpirationField?: boolean;
    appDataColumnId?: number;
    sequence?: number;
    skipConversion?: boolean;
    /**
     * used to add custom icons for actions -- for css use
     */
    actions?: Action[];
    childHeader?: GridHeader;
    isHoldIndicator?: boolean;
    /**
     * used to bind the value from the data property -- for css use
     */
    dataStyleClass?: string;
    /**
    * used to bind the css class from the header -- for css use
    */
    headerStyleClass?: string;
    skipForDownload?: boolean;
    selectRow?: boolean;
    selectId?: string;
    disableSelect?: string;
    cssClasses?: { key: string, class: string }[];
    allRowSelected?: boolean;
    isDropdownField?: boolean;
    dropDownList?: { key: string|number, value: string, showReason?: boolean }[];
    subFields?: { key: string }[];
    imgUrl?: string;
    icon?: string;
    disableField?: string;
    importAction?: boolean;
    showIndicator?: string;
    indicatorField?: string;
    mismatchColumn?: string;
}

export interface GridData {
    accessionNumber: string;
    aliquotCreatedDate: string;
    barcodeNumber: string;
    parentContainer?: string;
    cancellationDescription: string;
    containerLabelLine1: string;
    containerLabelLine2: string;
    containerNumber: number;
    containerReceiptDate: Date;
    currentSampleStatus: string;
    expectedReceiptCondition: string;
    specimenType: string;
    isOnSMHold: boolean;
    smToolTip: string;
    subjectNumber: string;
    protocolCode: string;

    childAliquotDate?: string;
    parentAliquotDate?: string;
    barcode: string;
    parentBarcode?: string;
    isDirectChild?: boolean;
    expandData?: { child: GridData[], parent: GridData[] };
    cssClass?: string;
    parentDataForDownload?: string[];
    childDataForDownload?: string[];
}

export interface GridDetails {
    data: any;
    header: GridHeader[];
}

export interface GridEvent {
    data: any;
    header: GridHeader;
    isChild?: boolean;
}

export interface CheckBoxEvent {
    key: string;
    isChecked: boolean;
    label: string;
    id: number;
}

export interface Action {
    title?: string;
    displayText?: string;
    description?: string;
    actionType: ActionType;
    cssClass?: string;
    key?: string;
    helpTextClass?: string;
    disableAction?: string;
}

export enum ActionType {
    none = 0,
    edit = 1,
    enable = 2,
    notify = 3,
    run = 4,
    delete = 5,
    exportExcel = 6,
    exportCsv = 7,
    resume = 8,
    view = 9,
}